import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { TreeStore } from '@/stores/local/shared/TreeStore';

import { TreeContext } from './context';
import { TreeNodeRenderFunction } from './types';

type Props = {
  className?: string;
  store: TreeStore;
  renderNode: TreeNodeRenderFunction;
  beforeSlot?: React.ReactNode;
};

const Tree: React.FC<Props> = ({ store, renderNode, className, beforeSlot }) => {
  const value = React.useMemo(() => ({ renderNode }), [renderNode]);

  return (
    <TreeContext.Provider value={value}>
      <div className={className}>
        {beforeSlot}
        {store.children.map(renderNode)}
      </div>
    </TreeContext.Provider>
  );
};

export default observer(Tree) as typeof Tree;
